module.exports = __webpack_public_path__ + "assets/img/正骨2.cbda411f.jpg";